import axios from '../api/axiosInstance';

export const fetchAvailabilityRules = (params) => {
  return axios.get('/availability-rules', { params });
};

export const createAvailabilityRule = (data) => {
  return axios.post('/availability-rules', data);
};

export const updateAvailabilityRule = (id, data) => {
  return axios.put(`/availability-rules/${id}`, data);
};

export const updateAvailabilityRuleStatus = (id, isActive) => {
  return axios.patch(`/availability-rules/${id}/status`, { isActive });
};

export const deleteAvailabilityRule = (id) => {
  return axios.delete(`/availability-rules/${id}`);
};

